/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { css, styled } from 'fierry/react.old/styled';


export default styled.div`

  display: grid;

  grid-template-columns: 1fr;
  grid-template-rows: 1fr;

  > *
  {
    grid-row: 1;
    grid-column: 1;

    width: 100%;
    height: 100%;
  }
`;
